import { MAX_ITEMS_IN_PAGE } from '../../actions/commonActions';

const initState = {
  clients: [],
  client: {},
  currentPage: 1, 
  totalPages: 0, 
  numItems: 0, 
  min: 1, 
  max: MAX_ITEMS_IN_PAGE,
  clientFilter: ''
}


const clientsReducer = (state = initState, action) => {
  switch (action.type) {
    case 'FETCH_CLIENTS':
      return {
        ...state,
        clients: action.clients
      }
    case 'SET_CLIENT_FIELD_CHANGE': 
      return {
        ...state, 
        client: Object.assign(state.client, action.value) 
      }
    case 'SET_CLIENT':
      return {
        ...state, 
        client: action.client 
      }
    case 'RESET_CLIENT':
      return {
        ...state,
        client: {}
      }
    case 'SET_CLIENTS_PAGINATION':
      return {
        ...state, 
        numItems: action.numItems, 
        min: action.min, 
        totalPages: action.totalPages,
        currentPage: typeof(action.currentPage) !== "undefined" ? action.currentPage : state.currentPage, 
        max: action.max 
      }
    case 'RESET_CLIENTS_PAGINATION':
      return {
        ...state, 
        currentPage: 1, 
        totalPages: 0, 
        numItems: 0, 
        min: 1, 
        max: MAX_ITEMS_IN_PAGE
      }
    case 'CLIENT_FILTER':
      return {
        ...state, 
        clientFilter: action.filter
      }
    default: 
      return state;
  }
}

export default clientsReducer